import React from "react";
import Container from "../../components/container";

const NotFound = () => {
  return (
    <Container className="max-w-[1200px]">
      <div className="container h-screen mt-40">
        <h1 className="text-white text-2xl ">Sorry Nothing found </h1>
      </div>
    </Container>
  );
};

export default NotFound;
